<template lang="html">
  <div class="login-screen">
    <div class="loader-wrapper">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'sso-redirect',
    created() {
      window.location.href = `${process.env.BACKEND_API_URL}sso/${this.$route.params.key}/redirect`;
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/login/SsoRedirect.vue